export default "__VITE_ASSET__c8b75397__"